import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import { toast } from "react-toastify";
import Pagination from "../../../assets/Pagination";
import TableLoader from "../../../loaders/TableLoader";
import AdminCashierAPI from "../../../../apis/adminApi/AdminCashierAPI";

const AdminCashAccountsIndex = () => {

    const [cashAccounts, setCashAccounts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchCashAccounts = async () => {
        try{
            const data =  await AdminCashierAPI.findCashAccounts();
            setCashAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes sources !");
        }
    };



    //Au chargement du composant on va chercher les cashAccounts
    useEffect(() => {
        fetchCashAccounts();
    }, []);


    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;

    //Filtrage des cashAccounts en fonction de la recherche

    const filteredCashAccounts = cashAccounts.filter(
        b =>
            b.name.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedCashAccounts = Pagination.getData(
        filteredCashAccounts,
        currentPage,
        itemsPerPage
    );

    let numerotation = 1;


    return (
        <>
            <div className="pagetitle">
                <h1>Les cashAccounts</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/cashier">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Les comptes source</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-md-7">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <h5 className="card-title">Total {cashAccounts ? cashAccounts.length : 0}</h5>
                                    </div>
                                    <div className="col-6">
                                        <Link className="btn btn-sm btn-primary mt-3 d-block" to="/admin/cashier/cashAccounts/add">
                                            <i className="bi bi-plus-circle"></i> Ajouter un compte source
                                        </Link>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="text" onChange={handleSearch} autoComplete="off" value={search} className="form-control" placeholder="Rechercher ..." />
                                </div>
                                <table className="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nom</th>
                                        <th scope="col">Montant</th>
                                        <th scope="col">Devise</th>
                                        <th scope="col">Options</th>
                                    </tr>
                                    </thead>
                                    {!loading && <tbody>
                                    {paginatedCashAccounts.map((cashAccount) => (
                                            <tr key={cashAccount.id}>
                                                <th scope="row">{numerotation++}</th>
                                                <td>{cashAccount.name}</td>
                                                <td>{cashAccount.t_amount}</td>
                                                <td>{cashAccount.currency}</td>
                                                <td>
                                                    <Link className="btn btn-sm btn-outline-primary mx-1" to={`/admin/cashier/cashAccounts/edit/${cashAccount.id}`}>
                                                        <i className="bi bi-pen-fill"></i>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>}
                                </table>
                                {loading && <TableLoader width={300} height={350} />}

                                {itemsPerPage < filteredCashAccounts.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredCashAccounts.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                                }

                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default AdminCashAccountsIndex;
